import React, { useState, useEffect } from 'react';
import TopNavbar from '../components/TopNavbar/TopNavbar';
import Table from '../components/Table/Table';
import SearchBar from '../components/SearchBar/SearchBar';
import ApiManager from '../ApiManager/ApiManager';
import NewTripType from './NewTripType';
import Modal from '../components/Modal/Modal';
import ViewEntity from '../components/ViewEntity/ViewEntity';
import PERMISSIONS from '../permissions';
import { ShowButton } from '../components/RoleBasedComponents';
import { useComponentLoading } from '../utils/useComponentLoading';


const columns = [
  {field: 'type', headerName: 'TripType'},
  {field: 'name', headerName: 'Name'},
  {field: 'hours_days', headerName: 'Hours/Days'},
  {field: 'km', headerName: 'KM'},
];
const view_columns = [
  {field: 'type', headerName: 'TripType'},
  {field: 'name', headerName: 'Name'},
  {field: 'hours', headerName: 'Hours'},
  {field: 'days', headerName: 'Days'},
  {field: 'km', headerName: 'KM'},
];



function TripTypes() {

  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  
  const { 
    withLoading, 
    isLoading, 
    getProgress, 
    getMessage, 
    updateProgress 
  } = useComponentLoading();

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };  

  const handleEdit = () => {
    console.log("Edit clicked for row:");
    setDetails(false);
    setEdit(true);
    setModalOpen(true);
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleRowClick = (row) => {
    setRowId(row);
  };


  const buttons=[
    { label: "Details", onClick: () => handleDetails() },
  ];

  const flattenJSON = (data) => {
    const result = { ...data };
    for (const key in data) {
      if (typeof data[key] === "object" && data[key] !== null && !Array.isArray(data[key])) {
        const nestedObject = data[key];
        for (const nestedKey in nestedObject) {
          result[`${nestedKey}`] = nestedObject[nestedKey];
        }
        delete result[key];
      }
    }
    return result;
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('tripTypes', async (onProgress) => {
        onProgress(10, 'Preparing to fetch trip types...');
        
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        
        onProgress(30, 'Fetching trip types data...');
        const response = await ApiManager.getAllTripTypes(params);
        
        if (!response.ok) throw new Error("Failed to fetch trip types");
        
        onProgress(60, 'Processing trip types data...');
        const json = await response.json();
        
        onProgress(90, 'Updating trip types display...');
        setData(json);
        setHasMorePages(json.length == 12);
        
        onProgress(100, 'Trip types loaded successfully');
      }, 'Loading trip types...');
    } catch (error) {
      console.error("Error fetching trip types:", error);
      setHasMorePages(false);
    }
  };

  useEffect(() => {
    const fetchRowData = async () => {
      try {
        await withLoading('tripTypeDetails', async (onProgress) => {
          onProgress(10, 'Preparing to fetch trip type details...');
          
          const query = new URLSearchParams({
            tripTypeId: rowId,
          });
          
          onProgress(30, 'Fetching trip type details...');
          const response = await ApiManager.getTripType(query);
          
          if (!response.ok) throw new Error("Failed to fetch trip type details");
          
          onProgress(60, 'Processing trip type details...');
          const json = await response.json();
          
          onProgress(90, 'Updating trip type details display...');
          setRowData(flattenJSON(json));
          
          onProgress(100, 'Trip type details loaded successfully');
        }, 'Loading trip type details...');
      } catch (error) {
        console.error("Error fetching trip type details:", error);
      }
    };

    if (rowId) {
      fetchRowData();
    }
  }, [rowId]);


  const rows = (data || []).map((item) => ({
    id: item.id,
    type: item.type,
    name : item.name,
    hours_days: item.meta.hours ? item.meta.hours : item.meta.days,
    km: item.meta.km,
  }));


  return (
    <div>
        <TopNavbar
           title="Trip Types"
        />
      <div
        style={{
          display: 'flex',
          justifyContent: 'right',
          width: '100%',
          paddingTop: '20px',
          height:'5vh'
        }}
        >
        {/* <SearchBar /> */}
        <ShowButton permission={PERMISSIONS.VENDOR_TRIP_TYPE_CREATE}>
          <NewTripType onSuccess={fetchData}/>
        </ShowButton>
        
      </div>
      <Table
        table_columns={columns}
        rows={rows}
        setRowsId={setRowId}
        buttons={buttons}
        onRowClick={handleRowClick}
        toggleModel={toggleModal}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        hasMorePages={hasMorePages}
        isLoading={isLoading('tripTypes')}
        loadingMessage={getMessage('tripTypes')}
        loadingProgress={getProgress('tripTypes')}
      />
      {isModalOpen && isDetails && (
          <div className="details-container">
              <Modal isOpen={true} onClose={handleModalClose}>
                  <ViewEntity
                    id={rowId}
                    data={rowData}
                    columns={view_columns}
                    entity="tripTypeId"
                    isLoading={isLoading('tripTypeDetails')}
                    loadingMessage={getMessage('tripTypeDetails')}
                    loadingProgress={getProgress('tripTypeDetails')}
                  />
              </Modal>
          </div>
          )}
    </div>
  );
}

export default TripTypes;
